import { useState, useCallback, useRef } from "react";
import { Header } from "../../../common/Header/Header.jsx";
import { yupResolver } from "@hookform/resolvers/yup";
import * as schemas from "../../../../assets/schemas/schemas.js";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  NewCraneProviderForm,
  NewInternalProviderForm,
  NewVehicularAssetForm,
} from "../../../common/Forms/Form";
import { statesService } from "../../../../services/statesService";
import { vehicleService } from "../../../../services/vehicleService";
import { providersService } from "../../../../services/providersService.js";
import { filterOptionById, isCraneVehicleClass } from "../../../../assets/helpers/funciones.js";
import { notify } from "../../../../assets/helpers/toast.js";
import { LoadSpinner } from "../../../common/LoadSpinner/LoadSpinner";
import { providersOptions, prodiverStatys } from "../../../../assets/helpers/options.js";
import { useDropzone } from "react-dropzone";
import { vehicularAssetsService } from "../../../../services/vehicularAssetsService.js";
import "./NewProvider.scss";

export const NewProvider = () => {
  let history = useHistory();
  const { t } = useTranslation();
  const [statesOptions, setStatesOptions] = useState([]);
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schemas.CreateProviderSchema(t)),
  });

  const onSubmit = handleSubmit(async (data) => {
    if (!isLoading) {
      setIsloading(true);
      providersService
        .createProvider(data)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Proveedor externo creado con éxito`, "success");
            history.push("/providers/external");

            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getStates = () => {
    statesService
      .getStates()
      .then((response) => {
        if (response.status === 200) {
          setStatesOptions(response?.data?.states);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const getCities = async (cityId) => {
    if (!cityId) return
    statesService
      .getCities(cityId)
      .then((response) => {
        if (response.status === 200) {
          setCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch(() => { });
    return true;
  };

  const cancelEdition = () => {
    history.push("/providers/external");
  };

  useState(() => {
    getStates();
    setValue("type", providersOptions[1]?._id);
    setValue("isInternal", false);
    setValue("isActive", true);
  }, []);

  return (
    <>
      <Header />
      <LoadSpinner label={"Enviando"} show={isLoading} />
      <div className="container">
        <div className="card incidence-card">
          <div style={{ margin: "0px" }} className="buttons-container">
            <h2 style={{ margin: "0px" }}>Nuevo Proveedor Externo</h2>
          </div>
          <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
          <NewCraneProviderForm
            t={t}
            register={register}
            errors={errors}
            watch={watch}
            action={onSubmit}
            options={{ statesOptions: statesOptions, citiesOptions: citiesOptions, prodiverStatys: prodiverStatys }}
            onChange={{ getCities: getCities }}
            cancel={cancelEdition}
          />
        </div>
      </div>
    </>
  );
};

export const NewInternalProvider = () => {
  let history = useHistory();
  const { t } = useTranslation();
  const [statesOptions, setStatesOptions] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schemas.NewInternalProviderSchema(t)),
  });

  const onSubmit = handleSubmit(async (data) => {
    if (!isLoading) {
      setIsloading(true);
      providersService
        .createProvider(data)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Proveedor interno creado con éxito`, "success");
            history.push("/fleet/internal");

            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getStates = () => {
    statesService
      .getStates()
      .then((response) => {
        if (response.status === 200) {
          setStatesOptions(response?.data?.states);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const cancelEdition = () => {
    history.push("/fleet/internal");
  };

  useState(() => {
    getStates();
    setValue("isInternal", true);
    setValue("isActive", true);
  }, []);

  return (
    <>
      <Header />
      <LoadSpinner label={"Enviando"} show={isLoading} />
      <div className="container">
        <div className="card incidence-card">
          <div style={{ margin: "0px" }} className="buttons-container">
            <h2 style={{ margin: "0px" }}>Registrar Chofer</h2>
          </div>
          <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
          <NewInternalProviderForm
            t={t}
            register={register}
            errors={errors}
            action={onSubmit}
            cancel={cancelEdition}
            options={{ statesOptions: statesOptions }}
          />
        </div>
      </div>
    </>
  );
};

export const NewVehicularAsset = () => {
  let history = useHistory();
  const { t } = useTranslation();
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [internalProvidersOptions, setInternalProvidersOptions] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [rcv, setRCV] = useState([]);
  const [propertyTitle, setPropertyTitle] = useState([]);
  const vehicleClassesOptionsRef = useRef([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    resolver: (data, context, options) =>
      yupResolver(
        schemas.CreateVehicularAssetSchema(t, vehicleClassesOptionsRef.current)
      )(data, context, options),
  });

  vehicleClassesOptionsRef.current = vehicleClassesOptions;

  const getinternalProviders = (type) => {
    let params = {
      limit: 100,
      offset: 0,
      isInternal: true,
      type: type,
    };

    if (params.type === "GRÚA") {
      params.type = "Grua";
    } else if (params.type === "MOTO") {
      params.type = "Asistente Vial";
    } else {
      delete params.type;
    }

    providersService.getProvidersByType(params).then((response) => {
      if (response.status === 200) {
        response.data.providers.map((provider) => {
          return (provider.name = provider.contactName);
        });
        setInternalProvidersOptions(response.data.providers);
      } else {
        notify(`${response.message}` || "error", "error");
      }
    });
    return true;
  };


  const onSubmit = handleSubmit(async (data) => {
    const providersDrivers = selectedProviders.map(provider => provider._id);

    const dataToPost = {
      ...data,
      providersDrivers: providersDrivers,
    }

    if (!isCraneVehicleClass(filterOptionById(vehicleClassesOptions, dataToPost.class))) {
      delete dataToPost.type;
    }

    delete dataToPost.provider

    const formData = new FormData();

    for (const key in dataToPost) {
      if (Array.isArray(dataToPost[key])) {
        dataToPost[key].forEach((item, idx) => {
          formData.append(`${key}[${idx}]`, item);
        });
      } else if (dataToPost[key] !== undefined && dataToPost[key] !== null) {
        formData.append(key, dataToPost[key]);
      }
    }

    if (propertyTitle.length > 0) {
      formData.append("propertyTitle", propertyTitle[0]);
    }
    if (rcv.length > 0) {
      formData.append("rcv", rcv[0]);
    }

    if (!isLoading) {
      setIsloading(true);
      vehicularAssetsService
        .createVehicularAsset(formData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Vehículo creado con éxito`, "success");
            history.push("/fleet");
            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getVehicleClasses = () => {
    vehicleService
      .getVehicleClasses(true)
      .then((response) => {
        if (response.status === 200) {
          setVehicleClassesOptions(response?.data?.classes);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const getVehicleBrands = () => {
    vehicleService
      .getVehicleBrands(watch("class"))
      .then((response) => {
        if (response.status === 200) {
          setBrandOptions(response?.data?.vehicleBrands);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const getVehicleModels = () => {
    vehicleService
      .getVehicleModels(watch("brand"))
      .then((response) => {
        if (response.status === 200) {
          setModelOptions(response?.data?.models);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const cancelEdition = () => {
    history.push("/fleet");
  };

  const addProvider = () => {

    const provider = watch('provider');
    let providerData = internalProvidersOptions.find((p) => p._id === provider);

    if (selectedProviders.some((p) => p._id === providerData._id)) {
      notify("Proveedor ya se encuentra seleccionado", "info");
      setValue("provider", "");
      return;
    }
    setSelectedProviders([...selectedProviders, providerData]);
    setValue("provider", "");
  };

  const removeProvider = (index) => {
    setSelectedProviders((prev) => prev.filter((_, i) => i !== index));
  };


  const handleVehicleType = () => {

    let vehiCletype = filterOptionById(vehicleClassesOptions, watch('class'))

    getinternalProviders(vehiCletype?.name);
    getVehicleBrands()
    setSelectedProviders([])
    if (!isCraneVehicleClass(vehiCletype)) {
      setValue("type", "");
    }
  }

  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        if (
          !["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(
            file.type
          )
        ) {
          notify(
            "Agregar un formato válido de imagen (PNG, JPG, JPEG)",
            "error"
          );
          return;
        }
        let maxWeight = 5; // MB
        if (file.size * 0.000001 > maxWeight) {
          notify(`La imagen no debe superar los ${maxWeight} MB`, "error");
          return;
        }
        else {
          let files = propertyTitle;
          files[0] = acceptedFiles[0];
          setPropertyTitle([...files]);
        }
      });
    },
    []
  );

  const onDrop2 = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        if (
          !["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(
            file.type
          )
        ) {
          notify(
            "Agregar un formato válido de imagen (PNG, JPG, JPEG)",
            "error"
          );
          return;
        }

        let maxWeight = 5; // MB
        if (file.size * 0.000001 > maxWeight) {
          notify(`La imagen no debe superar los ${maxWeight} MB`, "error");
          return;
        }
        else {
          let files = rcv;
          files[0] = acceptedFiles[0];
          setRCV([...files]);
        }
      });
    },
    []
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const { getRootProps: getRootProps2, getInputProps: getInputProps2 } = useDropzone({ onDrop: onDrop2 });


  useState(() => {
    getVehicleClasses();
  }, []);

  return (
    <>
      <Header />
      <LoadSpinner label={"Enviando"} show={isLoading} />
      <div className="container">
        <div className="card incidence-card">
          <div style={{ margin: "0px" }} className="buttons-container">
            <h2 style={{ margin: "0px" }}>Nuevo Vehículo</h2>
          </div>
          <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
          <NewVehicularAssetForm
            t={t}
            register={register}
            errors={errors}
            action={onSubmit}
            options={{
              vehicleClassesOptions: vehicleClassesOptions,
              brandOptions: brandOptions,
              modelOptions: modelOptions,
              internalProvidersOptions: internalProvidersOptions,
              selectedProviders: selectedProviders
            }}
            cancel={cancelEdition}
            control={control}
            watch={watch}
            onChange={{
              getVehicleBrands: getVehicleBrands,
              getVehicleModels: getVehicleModels,
              handleVehicleType: handleVehicleType,
              addProvider: addProvider,
              removeProvider: removeProvider
            }}
            getRootProps={getRootProps}
            getInputProps={getInputProps}
            getRootProps2={getRootProps2}
            getInputProps2={getInputProps2}
            propertyTitle={propertyTitle}
            rcv={rcv}
          />
        </div>
      </div>
    </>
  );
};
